import type { RememberVisitorValue } from '@elfsight/configurator-contracts';

export const getRememberVisitorValue = (
  controlValue: RememberVisitorValue | undefined
): number => {
  return controlValue?.value === 'custom'
    ? controlValue.customNumber * controlValue.customPeriod
    : Number(controlValue?.value);
};
